import { render, staticRenderFns } from "./FreeMortgageWatchAlert.vue?vue&type=template&id=555f5f68&"
import script from "./FreeMortgageWatchAlert.vue?vue&type=script&lang=js&"
export * from "./FreeMortgageWatchAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports